var option_webview_default = {
  "option": "BRcwv",
  "user_choice": "_6sS9w",
  "check": "mWGck",
  "image": "q4msy",
  "input": "a5IGw",
  "title": "nXGMP",
  "centered": "G6mSc",
  "with_result": "Ceoeh",
  "list": "_-1k5C",
  "with_image": "fvCLb",
  "progress": "QIuQi",
  "progress_value": "JqFe5",
  "label": "D1UV1",
  "cta": "i41tz",
  "adornment_icon": "G-dIf",
  "remove": "zR-lU",
  "removeButton": "q-aYX",
  "removeButtonIcon": "_7kTfK",
  "overlay": "fJiot",
  "shown": "u6-6W",
  "dark": "_3AE6u",
  "spinner": "UMh58",
  "spin": "Sn8ZY",
  "grid": "JxY5r"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
